import { render, staticRenderFns } from "./PartnerNewDashboard.vue?vue&type=template&id=1e587923&scoped=true"
import script from "./PartnerNewDashboard.vue?vue&type=script&lang=js"
export * from "./PartnerNewDashboard.vue?vue&type=script&lang=js"
import style0 from "./PartnerNewDashboard.vue?vue&type=style&index=0&id=1e587923&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e587923",
  null
  
)

export default component.exports